import React from 'react';
import ReactDOM from 'react-dom/client';
import { initializeFirebase } from '@platform/core';
import App from './App';

// Initialize Firebase
initializeFirebase();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
